import { createSupabaseBrowserClient } from '@/lib/supabase/client';
import { getEnv } from '@/lib/env';
import type { ForgotPasswordInput } from '@/lib/schemas/auth/password-reset.schema';

export async function requestPasswordReset(input: ForgotPasswordInput) {
  const supabase = createSupabaseBrowserClient();
  const env = getEnv();
  const { error } = await supabase.auth.resetPasswordForEmail(input.email, {
    redirectTo: `${env.NEXT_PUBLIC_APP_URL}/auth/callback?next=/reset-password`,
  });
  if (error) throw error;
}
